module.exports = __webpack_public_path__ + "static/media/sign-lez--gray.0d1a6a89.svg";